/**
 * @description {博客栏目 相关接口 }
 */
import { api } from '@/utils/http'

const COLLECTION_LIST = '/collection/list'
const COLLECTION_ADD = '/collection/add'
const COLLECTION_UPDATE = '/collection/update'
const COLLECTION_DEL = '/collection/del'

export function collectionList(data){
    return api({url:COLLECTION_LIST, method:'POST', data})
}

export function collectionAdd(data){
    return api({url:COLLECTION_ADD, method:'POST', data})
}

export function collectionUpdate(data){
    return api({url:COLLECTION_UPDATE, method:'POST', data})
}

export function collectionDel(data){
    return api({url:COLLECTION_DEL, method:'POST', data})
}

